var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHeartHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.714 11.489h.835l.996-1.68a.462.462 0 01.43-.23.466.466 0 01.4.274l.749 1.636h.93c.218 0 .405.147.456.36l.172.704.925-.932a.464.464 0 01.332-.138h2.988c.049-.242.073-.49.073-.743 0-.998-.386-1.938-1.088-2.645a3.687 3.687 0 00-4.91-.298 3.69 3.69 0 00-4.914.298A3.72 3.72 0 006 10.74c0 1 .384 1.94 1.088 2.647l4.58 4.618c.092.09.214.138.334.138.12 0 .242-.047.334-.138l4.58-4.62c.281-.284.512-.605.686-.953H15.138l-1.377 1.386a.466.466 0 01-.46.12.471.471 0 01-.33-.342l-.285-1.158h-.862a.473.473 0 01-.428-.276l-.499-1.095-.677 1.138a.472.472 0 01-.405.233H8.714a.473.473 0 01-.47-.475c0-.26.21-.474.47-.474z",
    fill: "#31544e"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--heart-health-8f28a86a11a8a0f10cc7cd64078e7707.svg";
export { SvgIconUiHeartHealth as Component };